import api from 'services/api/microfwk';
import _ from 'lodash';

export const getCounterValidEmail = (params = {}) =>
  api
    .get('/services/user/countervalidemail', {
      params,
    })
    .then(({ data }) => {
      const status = _.get(data, 'response.status', _.get(data, 'status', 0));
      if (parseInt(status, 10) !== 0) {
        const error = _.get(
          data,
          'errors',
          _.get(data, 'response.errors', false),
        );
        if (error) return error;
        return {
          error: data,
        };
      }
      return data.response;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
